import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {RECAPTCHA_ACTIONS} from '../../constants/recaptcha';
import {TYPE_CLICK} from '../../constants/tagManager';
import {useRecaptchaProtection} from '../../hooks/useRecaptchaProtection';
import {sendCNPJ} from '../../services/Api';
import {checkErrorsEcDataAndCnpj} from '../../services/errorsMessages';
import {informCNPJ, informCNPJRequest} from '../../services/establishment';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../services/tagManager';
import {useChatStore} from '../../store/slices/chatStore';
import {useEcStore} from '../../store/slices/ecStore';
import {useInteractionStore} from '../../store/slices/interactionStore';
import {recaptchaLogger} from '../../utils/recaptchaMonitoring';
import Form from '../Form';

const Cnpj = (props) => {
  const ec = useEcStore((state) => state.ec);
  const setEcIdentity = useEcStore((state) => state.setEcIdentity);
  const updateEc = useEcStore((state) => state.updateEc);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setMessages = useChatStore((state) => state.setMessages);
  const setQuizPartners = useChatStore((state) => state.setQuizPartners);
  const [stop, setStop] = useState(false);
  const [userFlowCnpjMessage, setUserFlowCnpjMessage] = useState('');
  const {executeWithProtection} = useRecaptchaProtection();

  const saveCnpjDetails = async (dataCnpj, cnpjIdentifier) => {
    const ecData = {
      ...cnpjIdentifier,
      cnpj: dataCnpj.value
    };

    setStop(true);

    try {
      const response = await executeWithProtection(
        (payload, token) => sendCNPJ(payload, token),
        RECAPTCHA_ACTIONS.QUOTATION_SUBMISSION,
        ecData
      );

      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-7:none:cnpj'
      });

      let showResponse = informCNPJRequest(response);
      setDotTyping(false);
      updateEc(showResponse.ec);
      setEcIdentity(ecData);
      setQuizPartners([
        {
          idQuestion: 1,
          typeMessage: 'partnerName'
        },
        {
          idQuestion: 2,
          typeMessage: 'birthDate'
        },
        {
          idQuestion: 3,
          typeMessage: 'phone'
        },
        {
          idQuestion: 4,
          typeMessage: 'email'
        },
        {
          idQuestion: 5,
          typeMessage: 'cpf'
        }
      ]);
      responseFlowChange(showResponse.responseFlow);
      responseTypeChange(showResponse.responseType);
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-8:none:cnpj-correto'
      });
      setMessages(dataCnpj.messages);
      setMessages(showResponse.messages);
    } catch (error) {
      setDotTyping(false);
      recaptchaLogger.error('Erro no credenciamento', {
        error: error.message,
        status: error.response?.status
      });
      const showResponse = checkErrorsEcDataAndCnpj(error);
      setMessages(showResponse.messages);
      responseFlowChange(showResponse.responseFlow);
      responseTypeChange(showResponse.responseType);
      setStop(false);
    }
  };

  const flowSubmitCNPJ = async (e) => {
    e.preventDefault();

    if (stop) return;
    if (userFlowCnpjMessage === '') return;
    setDotTyping(true);
    let data = ec.representativeData;
    let cnpjIdentifier = {
      cpf: data.cpf,
      cnpj: '',
      email: data.email,
      displayName: data.displayName,
      telephoneNumber: data.telephoneNumber,
      birthDate: data.birthDate
    };

    let dataCnpj = informCNPJ(userFlowCnpjMessage);
    if (!dataCnpj.status) {
      setDotTyping(false);
      if (dataCnpj.messages) {
        setMessages(dataCnpj.messages);
      }
      return;
    }
    saveCnpjDetails(dataCnpj, cnpjIdentifier);
  };

  return (
    <Form
      dataTestId="form-input-cnpj"
      onSubmit={flowSubmitCNPJ}
      valueType={props.valueType}
      valueFlow={props.valueFlow}
      disabled={props.disabled}
      value={userFlowCnpjMessage}
      onChange={setUserFlowCnpjMessage}
    />
  );
};

Cnpj.propTypes = {
  valueType: PropTypes.string,
  valueFlow: PropTypes.string,
  disabled: PropTypes.string
};

export default Cnpj;
